


















import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {toI18n, centerWinOptions} from '@/utils/commonUtils';
import {Grid} from '@toast-ui/vue-grid';

interface PageObj {
  page: number;
}

@Component
export default class ProductListStockSync extends Vue {
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_PRODUCTLIST_' + needToI18nStr));
  }

  @Prop({required: true})
  private readonly gridProps!: any;

  @Prop({required: true, default: () => []})
  private readonly data!: [];

  @Prop({
    required: false,
    default: function () {
      return {};
    },
    type: Object
  })
  private readonly gridOptions?: {[propName: string]: any};

  @Prop({required: false, default: false, type: Boolean})
  private readonly isShow?: boolean;

  private options = {
    header: {
      height: 33
    },
    columnOptions: {
      minWidth: 50
    },
    minRowHeight: 28,
    rowHeight: 28,
    bodyHeight: 460,
    useClientSort: false
  };

  private bodyHeight = 460;

  @Watch('data')
  onDataChanged() {
    const grid = this.$refs.stockSyncTuiGrid as Grid;
    grid.invoke('resetData', this.data as any);
    grid.invoke('setBodyHeight', this.data.length === 0 ? 190 : this.bodyHeight);

    this.$nextTick(() => {
      if (grid) {
        grid.invoke('refreshLayout');
      }

    });
  }

  private close() {
    this.$emit('close');
  }

  private async created() {
    Object.assign(this.options, {rowHeaders: this.gridProps.rowHeaders || ['rowNum']});

    if (this.gridOptions && Object.keys(this.gridOptions) && this.gridOptions.constructor === Object) {
      if (this.gridOptions.bodyHeight) {
        this.bodyHeight = this.gridOptions.bodyHeight;
      }
      Object.assign(this.options, this.gridOptions);
    }

    const {data: customPropertyData} = await this.$api.getCustomPropertyUsable();
    const propertyNames = customPropertyData
      .filter((item: any): boolean => item.used)
      .map(({propertyNo, propertyName, multiSelectionEnabled}) => {
        return {
          header: propertyName,
          name: `customProperties${propertyNo}`,
          align: 'center',
          formatter: ({row}: any): string => {
            const property = row.customProperties.find((property: any): boolean => property.propertyNo === propertyNo);
            let value = '';
            const propValue = {...property};
            if (row.customProperties.length && property) {
              if (typeof multiSelectionEnabled === 'boolean' && !multiSelectionEnabled) {
                value = propValue.propertyValue;
              } else {
                const url = `/product/popup/customProperty/${row.mallProductNo}/${propValue.propertyValue}?propertyName=${propValue.propertyName}`;
                value = `<a href="javascript:onclick=window.open('${url}','customProperty','${centerWinOptions(523, 237)}')">${propValue.propertyValue}</a>`;
              }
            } else {
              value = '-';
            }
            return value;
          },
          copyOptions: {
            customValue: (value): string => {
              return value;
            }
          }
        };
      });

    propertyNames.forEach((column: any): void => {
      this.gridProps.columns.splice(this.gridProps.columns.length - 1, 0, column);
    });

    setTimeout(() => {
      // this.gridProps.columns[3].formatter = ({value, row}: any): string => {
      //   if (row.isStockSync) {
      //     if (row.parentMallProductNo === 0) {
      //       return `(M) ${value}`;
      //     }
      //     return `(S) ${value}`;
      //   }

      //   return value;
      // };
      setTimeout(() => {
        const grid = this.$refs.stockSyncTuiGrid as Grid;
        grid.invoke('setColumns', this.gridProps.columns);
      });
    });
  }

  private mounted() {
    const grid = this.$refs.stockSyncTuiGrid as Grid;
    grid.invoke('on', 'mousedown', (ev: any) => {
      if (ev.targetType === 'columnHeader') {
        $('th[data-column-name="' + ev.columnName + '"]').removeClass('tui-grid-cell-selected');
      }
      let tagName = ev.nativeEvent.target.tagName;
      if (tagName === 'SELECT' || tagName === 'INPUT') {
        ev.stop();
      }
    });
  }
}
